import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {
    clearAccessTokenAndRedirectToLogin,
    forgetPasswordUrl,
    verifyCodeUrl
} from "./../../config";
import ActivateForm from "../../components/ActivateForm";
import {Link} from "react-router-dom";


class ForgetPassword extends Component {
    state = {
        mobile: null,
        ForgetPasswordLoading: false,
        NewPasswordLoading: false,
        verifyLoading: false,
        isForgetPasswordError: false,
        isForgetPasswordErrorMsg: null,
        isNewPasswordError: false,
        isNewPasswordErrorMsg: null,
        isActive: false,
        errorMsg: false,
        new_password: "",
        pin: null,
        errorMsgText: null,
    };
    /*    componentDidMount() {
            const mobile = JSON.parse(window.localStorage.getItem("mobile") || null);
            console.log(mobile)
            this.setState({
                mobile: mobile,
            })
            console.log("before",this.state)
        }*/
    handleInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };
    verifyCode = (e) => {
        e.preventDefault();
        const mobile = JSON.parse(window.localStorage.getItem("mobile") || null);
        this.setState({
            mobile: mobile,
        })
        axios.post(verifyCodeUrl, this.state).then(res => {
            // start loading
            this.setState({
                verifyLoading: false,
            });
            if (res.data.Error.code === 20) {
                localStorage.setItem("isActive", "1");
                this.props.history.push("/reset-password");
            } else {
                this.setState({
                    errorMsgText: res.data.Error.desc,
                    errorMsg: true,
                    verifyLoading: false,
                })
            }
        }).catch(error => {
            this.setState({
                verifyLoading: true,
            });
            console.log(error);
            clearAccessTokenAndRedirectToLogin(error)
        })
    };
    forgetPassword = (e) => {
        // start loading
        this.setState({
            ForgetPasswordLoading: true,
        });
        // prevent default behavior
        e.preventDefault();
        const form = document.getElementById("forget-password-form");

        const errorDesc = document.getElementById("error-msg");

        axios.post(forgetPasswordUrl, this.state).then(res => {

            // stop loading
            this.setState({
                ForgetPasswordLoading: false,
            });

            if (res.data.Error.code === 20) {
                // cache user & access token
                localStorage.setItem("mobile", JSON.stringify(this.state.mobile));

                form.reset();

                this.setState({
                    isActive: true,
                });
            } else {
                switch (res.data.Error.code) {
                    case 24:
                        errorDesc.innerHTML = res.data.Error.desc;
                        this.setState({
                            isForgetPasswordError: true,
                        });
                        break;
                    default:
                        break;
                }
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                ForgetPasswordLoading: true,
            });
        });
    };

    render() {
        const {ForgetPasswordLoading, isForgetPasswordError} = this.state;
        const {translate} = this.props;
        return (
            <div>
                {!this.state.isActive ?
                    <div className="wrap-login100 p-l-50 p-r-50 p-t-120 p-b-50" hidden={this.state.isActive === true}>
                        <form onSubmit={(e) => this.forgetPassword(e)} id="forget-password-form"
                              className="login100-form validate-form">
                            <a href="/" className="logo-auth"> <img src="images/logo.png" alt="seena logo"/>
                            </a>
                            <span className="login100-form-title p-b-59">
                            {translate('forget_password')}
                        </span>
                            <span id="error-msg" className="full-width" hidden={isForgetPasswordError === false}></span>
                            <div className="wrap-input100 validate-input">
                                <input id="mobile" type="text" className="form-control input100 curvy-input"
                                       onChange={this.handleInputChange}
                                       placeholder="Enter your mobile number" required/>
                            </div>
                            <div className="container-login100-form-btn relative">
                                <button type="submit"
                                        className="login100-form-btn btn-block cursor-pointer curvy-input height-45">{translate("submit")}
                                </button>
                                <span id="loading" className="auth-loading"
                                      hidden={ForgetPasswordLoading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                            </div>
                            <div className="text-center link-area full-width">
                                <Link to="/"><span>{"<- " + translate("back_to_home")} </span></Link>
                            </div>
                        </form>
                    </div> :
                    <div>
                        <ActivateForm onSubmission={this.verifyCode}
                                      errorMsg={this.state.errorMsg}
                                      errorMsgText={this.state.errorMsgText}
                                      handleInputChange={this.handleInputChange}
                                      loading={this.state.verifyLoading}/>
                    </div>
                }
            </div>
        )
    }
}


export default withRouter(withTranslate(ForgetPassword))



